import { render, staticRenderFns } from "./ElectricVehicleQuestionForm.vue?vue&type=template&id=bc0ecd36"
import script from "./ElectricVehicleQuestionForm.vue?vue&type=script&lang=ts"
export * from "./ElectricVehicleQuestionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports